export const environment = {
  production: true,
  URL_BASE: 'https://expogenetic-braford-admin-dev.tecnologiabi.net/api/',
  API_KEY_GOOGLE_MAPS: 'AIzaSyBAu0TZSyAyEbmwpedVh2xlANnCMmaVojk',
  FEATURES: { 
  requireInternalRoleForModeracion: true,
  signalrDirectWebSocket: true,
    pistaLivePollingIntervalMs: 10000,
    pistaLivePollingMaxBackoffMs: 15000,
    premiacionPollingIntervalMs: 10000,
    uiRouteTransitionsEnabled: true,
    uiRouteTransitionDurationMs: 1320,
    uiRouteTransitionDistancePx: 520,
    uiSmoothScrollEnabled: true,
    uiRespectReducedMotion: true,
    catalogoAutoFocusFromNav: true
  },
  premiacionWsDebugEnabled: true,
  pistaLiveDebugEnabled: true,
  GA4: {
  enabled: true,
  measurementId: 'G-XXXXXXXXXX',  // property DEV
  debugMode: true
},
  // Colores:
  // BRAFORD Bordo: #992b31
  // BRAFORD Rojo: #a0171d
  // BRAFORD Verde: #4caf50
  // BRAFORD Azul: #003062
  // Integra: #22c5a2

  // Logos:
  // Icono: assets/brand/brangus_silhouette_icon_black.svg
  // Wordmark: assets/brand/logo-wordmark.svg
  // Secundario: assets/brand/integra_hub2.png
  // Circular: assets/brand/logo_integra_circular.png

  // Otro Logo: assets/brand/StartAppIcon.svg
  // Otro Logo: assets/brand/logo_tecbi_small1.png
  BRAND: {
    name: 'Expo Genetic',
    appName: 'Catalogo Virtual Braford',
    tagline: 'ExpoGenetic PWA',
    pageTitle: 'Catalogo Virtual Braford',
    metaDescription: 'Catalogo virtual de exposiciones powered by ExpoGenetic',
   themeColor: '#003062',
    backgroundColor: '#ffffff',
    faviconPath: 'assets/brand/expoGenetic/favicon.ico',
    appleTouchIconPath: 'assets/brand/expoGenetic/apple-touch-icon.png',
    manifestPath: 'manifest.webmanifest',
    ogSiteName: 'Expo Genetic',
    ogTitle: 'Catalogo Virtual Braford',
    ogDescription: 'Catalogo virtual de exposiciones powered by ExpoGenetic',
    ogImagePath: 'assets/brand/expoGenetic/android-chrome-512x512.png',
    ogUrl: 'https://app.expogenetic.com/',
    twitterCard: 'summary_large_image',
    twitterTitle: 'Expo Genetic',
    twitterDescription: 'Catalogo virtual de exposiciones powered by ExpoGenetic',
    twitterImagePath: 'assets/brand/expoGenetic/android-chrome-512x512.png',
    primaryColor: '#003062',
    primaryColor50: '#e6edf5',
    primaryColor100: '#ccdbe9',
    primaryColor200: '#99b7d3',
    primaryColor300: '#6693bd',
    primaryColor400: '#336fa7',
    primaryColor500: '#003062',
    primaryColor600: '#002a56',
    primaryColor700: '#00234a',
    primaryColor800: '#001d3e',
    primaryColor900: '#001632',
    primaryColor950: '#000f26',
    primaryColorStrong: '#00234a',
    secondaryColor: '#1f4f8b',
    primaryColorSoft: '#e6edf5',
    primaryColorMuted: '#5f7fa3',
    textOnPrimary: '#ffffff',

    // Logo Icono para header V1: recomendado en formato SVG con fondo transparente,
    // idealmente con un tamaño de 120x120 px o similar (relacion 1:1)
    // para asegurar una buena visualizacion en diferentes dispositivos y resoluciones.
    header: {
      v1: {
        logoIconPath: 'assets/brand/ExpoGenetic.png',
        logoIconLink: 'https://braford.org.ar/',
        logoIconBackgroundSize: '110%',
        logoWordmarkPath: 'assets/brand/logo-wordmark.svg',
        logoWordmarkLink: 'https://braford.org.ar/'
      },
       v2: {
        logoPrimaryPath: 'assets/brand/ExpoGenetic-logo-primario.png',
        primaryPanelPadding: '0.01rem 0 0 0',
        primaryGap: '0rem',
        primaryMaxHeight: '3rem',
        primaryMaxHeightMobile: '2.9rem',
        primaryObjectPosition: 'left center',
        primaryLineMaxWidth: '40ch',
        primaryLineMarginTop: '0.5rem',
        primaryLineOffsetX: '0.30rem',
        primaryLineOffsetY: '-0.2rem',
        primaryLineFontFamily: "'Montserrat', 'Segoe UI', sans-serif",
        primaryLineFontSize: '0.7rem',
        primaryLineFontSizeMobile: '0.7rem',
        primaryLineFontWeight: '800',
        primaryLineLetterSpacing: '0.15em',
        primaryLineLineHeight: '1',
        primaryLineTextTransform: 'none'
      },
      shared: {
        padding: '1rem 0.77rem 0.85rem',
        paddingMobile: '1rem 0.3rem 0.85rem 0.3rem',
        secondary: {
          logoSecondaryPath: 'assets/brand/logo_brangus.png',
          logoSecondaryLink: 'https://tecnologiabi.com/expogenetic/',
          cardInnerPadding: '0rem 0rem 0rem 0rem',
          cardInnerPaddingMobile: '0rem 0rem 0rem 0rem',
          cardOuterMargin: '0 0 0 auto',
          cardOuterMarginMobile: '0 0 0 auto',
          width: 'min(10.6rem, 76vw)',
          widthMobile: 'min(10.2rem, 34vw)',
          splitWidth: '100%',
          splitWidthMobile: '100%',
          splitHeight: 'auto',
          splitHeightMobile: 'auto',
          height: 'auto',
          heightMobile: 'auto',
          imageWidth: '12rem',
          imageWidthMobile: '100%',
          imageHeight: '4.5rem',
          imageHeightMobile: '3rem',
          maxHeight: '4.5rem',
          maxHeightMobile: '4rem',
          offsetX: '0rem',
          offsetXMobile: '0rem',
          objectFit: 'contain',
          objectFitMobile: 'contain',
          objectPosition: 'center',
          objectPositionMobile: 'center'
        }
      }
    },

    // Logo para pantalla Login Register.
    // Tamaño recomendado: 620x220 px (relacion aprox. 2.8:1), ideal en SVG con fondo transparente.
    // Puede ser una imgen tambien.
    logoAuthPath: 'assets/brand/logo_poweredby_tecbi3.png',


    //Colores del tocuh y focus en interacciones (ej: botones, links, inputs)
    interactionTapHighlightColor: 'var(--color-primary-200)',
    interactionFocusRingColor: 'rgba(32, 32, 197, 0.45)',

    //Dropdown (select): control + opciones (cuando el navegador permite estilarlas)
    dropdownBackgroundColor: '#ffffff',
    dropdownTextColor: '#1f2d41',
    dropdownBorderColor: '#e6dfe0',
    dropdownHoverBackgroundColor: '#ffffff',
    dropdownHoverBorderColor: 'var(--color-primary)',
    dropdownOptionBackgroundColor: '#ffffff',
    dropdownOptionTextColor: 'var(--color-primary)',
    dropdownOptionHoverBackgroundColor: 'var(--color-primary-50)',
    dropdownOptionSelectedBackgroundColor: 'var(--color-primary)',
    dropdownOptionSelectedTextColor: '#ffffff',
    // fontFamilyBase: "'Public Sans', 'Segoe UI', sans-serif",
    // fontFamilyHeading: "'Public Sans', 'Segoe UI', sans-serif",
    // fontStylesheetUrls: [
    //   'https://fonts.googleapis.com/css2?family=Public+Sans:wght@400;500;600;700;800&display=swap'
    // ],
    fontFamilyBase: "'Montserrat', 'Segoe UI', sans-serif",
    fontFamilyHeading: "'Public Sans', 'Segoe UI', sans-serif",
    fontStylesheetUrls: [
      'https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&family=Bebas+Neue&display=swap'
    ]
  }
};
